"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(theme) {
  return {
    root: {
      width: 400,
      textAlign: 'center',
      boxShadow: '0 2px 8px 0 rgba(0,0,0,0.28)',
      borderRadius: 4
    },
    dialogIcon: {
      margin: '0 auto',
      marginTop: 36,
      width: 48,
      height: 48
    },
    title: {
      paddingTop: '22px',
      paddingBottom: '18px',
      flexShrink: 1
    },
    content: {
      marginLeft: 24,
      marginRight: 24,
      padding: 0,
      flexShrink: 0
    },
    actions: {
      justifyContent: 'center',
      flexShrink: 1,
      '& button': {
        padding: '8px 30px',
        marginBottom: 40
      }
    }
  };
};

exports.default = _default;